export default __webpack_public_path__ + "39e76bde3347769329c3c0bd3ac41c56.svg";